import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { BarChartModule } from '@swimlane/ngx-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { HorizontalBarChartComponent } from './horizontal-bar.component';


@NgModule({
  declarations: [
    HorizontalBarChartComponent
  ],
  imports: [
    BarChartModule,
    FlexLayoutModule,
    FuseSharedModule,
    FuseWidgetModule,
    NgxSkeletonLoaderModule,
    TranslateModule
  ],
  exports: [
    HorizontalBarChartComponent
  ]
})
export class HorizontalBarChartModule {}
